<template>
  <!--  -->
  <div class="modal-overlay">
    <!-- <div class="modal-dialog modal-xl"> -->
    <div
      v-if="loading"
      class="mmodal-content"
      style="
        max-width: 97vw;
        position: relative;
        padding-top: 1em;
        padding-bottom: 1em;
      "
    >
      <button
        style="
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: red;
          color: white;
          border: none;
          padding: 5px 10px;
          cursor: pointer;
        "
        type="button"
        @click="closepModal"
      >
        <span style="font-size: 1.3em">X</span>
      </button>
      <h3 style="text-align: center">Loading...</h3>
    </div>

    <div v-if="!loading" class="mmodal-content" style="max-width: 97vw">
      <div class="modal-header mb-0">
        <table
          style="border: 1px solid #bbb; border-bottom: 2px solid black"
          class="table align-items-center mb-0"
        >
          <thead>
            <tr>
              <th scope="col" colspan="5">
                <h5 class="modal-title" id="createAppointmentLabel">
                  Issue Prescription
                </h5>
              </th>
              <th scope="col" style="display: flex; justify-content: flex-end">
                <button
                  style="background-color: red; color: white"
                  type="button"
                  @click="closepModal"
                >
                  <span style="font-size: 1.3em">X</span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style="color: black">
              <td scope="col">
                Patient Name: <b>{{ patient_name }}</b>
              </td>
              <td scope="col">
                Age:
                <!-- <b>{{ getAge(dob) }}</b> -->
              </td>
              <td scope="col">
                Gender: <b>{{ gender }}</b>
              </td>
              <td scope="col">
                Email: <b>{{ email }}</b>
              </td>
              <td scope="col">
                Phone: <b>{{ phone }}</b>
              </td>
              <td scope="col">
                OPD: <b>{{ opd }}</b> || IPD: <b>{{ ipd }}</b>
              </td>
              <!-- <td scope="col">
                <button @click="toggleEditMode" class="mycustom-success-button">
                  Edit mode
                </button>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-body">
        <!-- <div class="container"> -->

        <!-- </div>

        <div class="container"> -->
        <div class="mt-2 card parent-div">
          <div class="table-container">
            <div v-if="prescriptions.length < 1">
              <span style="color: maroon; align-self: center">
                There are non unissued drugs for this Prescription
              </span>
            </div>
            <table
              v-if="prescriptions.length > 0"
              class="table align-items-center mb-0"
            >
              <thead style="background-color: rgb(209, 209, 224)">
                <tr style="color: black">
                  <th width="7%" scope="col">#SID</th>
                  <th width="20%" scope="col">Medicine/Item Name</th>
                  <th width="10%" scope="col">Dosage</th>
                  <th width="10%" scope="col">Frequency</th>
                  <th width="8%" scope="col">Quantity</th>
                  <th v-if="rowsOnEditMode.length == 0" width="15%" scope="col">
                    SKU
                  </th>

                  <th width="10%" scope="col">Instructions</th>

                  <th v-if="rowsOnEditMode.length == 0" width="10%" scope="col">
                    Status
                  </th>
                  <th width="10%" scope="col">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="prescription in prescriptions"
                  :key="prescription.id"
                >
                  <th scope="row">{{ prescription.id }}</th>
                  <td style="color: black">
                    <span v-if="!rowsOnEditMode.includes(prescription.id)">
                      <ItemFormat
                        :ItemName="prescription.item_name"
                        :ItemBrand="prescription.brand_name"
                        :ItemStrength="prescription.item_strength"
                      />
                    </span>

                    <span
                      v-if="rowsOnEditMode.includes(prescription.id, $event)"
                    >
                      <iteminput
                        @itemoption-check="
                          (payload) => takeItem(prescription.id, payload)
                        "
                        :Rowid="prescription.id"
                        :preselectedItem="
                          getPreSelectedItem(
                            prescription.brand_name,
                            prescription.item_strength,
                            prescription.item_name,
                          )
                        "
                        :Store_id="prescription.store_id"
                        :type="'stock'"
                      />
                    </span>
                  </td>
                  <td>
                    <span v-if="rowsOnEditMode.includes(prescription.id)">
                      <input
                        type="text"
                        @change="handleEditChange(prescription.id, $event)"
                        name="new_dosage"
                        :value="prescription.dosage"
                      />
                    </span>

                    <span v-if="!rowsOnEditMode.includes(prescription.id)">
                      {{ prescription.dosage }}
                    </span>
                  </td>

                  <td>
                    <span v-if="rowsOnEditMode.includes(prescription.id)">
                      <input
                        type="number"
                        @change="handleEditChange(prescription.id, $event)"
                        name="new_frequency"
                        :value="prescription.frequency"
                      />
                    </span>

                    <span v-if="!rowsOnEditMode.includes(prescription.id)">
                      {{ prescription.frequency }}
                    </span>
                  </td>
                  <td>
                    <span v-if="rowsOnEditMode.includes(prescription.id)">
                      <input
                        type="number"
                        @change="handleEditChange(prescription.id, $event)"
                        name="new_quantity"
                        :value="prescription.quantity"
                      />
                    </span>

                    <span v-if="!rowsOnEditMode.includes(prescription.id)">
                      {{ prescription.quantity }}
                    </span>
                  </td>
                  <td v-if="rowsOnEditMode.length == 0">
                    <select
                      @change="changeSku(prescription.id, $event)"
                      class="form-select"
                      aria-label=""
                      :disabled="rowsOnEditMode.length > 0"
                    >
                      <option disabled selected>Select...</option>
                      <option
                        v-for="batch in batches[prescription.id]"
                        :selected="batch.batch_number == prescription.batch_no"
                        :key="batch.id"
                        :value="batch.batch_number"
                      >
                        {{ batch.batch_number }}
                      </option>
                    </select>
                    <!-- {{ prescription.batch_no }} -->
                  </td>

                  <td>
                    <span v-if="rowsOnEditMode.includes(prescription.id)">
                      <input
                        type="text"
                        @change="handleEditChange(prescription.id, $event)"
                        name="new_instructions"
                        :value="prescription.instructions"
                      />
                    </span>

                    <span v-if="!rowsOnEditMode.includes(prescription.id)">
                      {{ prescription.instructions }}
                    </span>
                  </td>

                  <td
                    v-if="rowsOnEditMode.length == 0"
                    :style="{
                      color: prescription.is_issued == '0' ? 'red' : 'green',
                    }"
                  >
                    {{ prescription.is_issued == "0" ? "Pending" : "Issued" }}
                    <span style="background-color: purple;" class="badge" v-if="restrict_unpaid && prescription.is_paid !=1"
                      >awaiting payment</span
                    >

                    <span style="background-color: green;" class="badge" v-if="restrict_unpaid && prescription.is_paid ==1"
                      >Ready to issue</span
                    >
                  </td>
                  <td>
                    <span v-if="!rowsOnEditMode.includes(prescription.id)">
                      <button
                        @click="switchEditMode(prescription.id)"
                        class="mycustom-secondary-button"
                      >
                        Edit</button
                      >.

                      <button
                        class="mycustom-danger-button"
                        @click="
                          displayConfirmDeleteMessageDialogue(prescription.id)
                        "
                      >
                        Delete
                      </button>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <span v-if="rowsOnEditMode.length > 0">
          <button @click="saveEdits()" class="btn btn-secondary btn-sm">
            Save</button
          >.
        </span>
        <span v-else>
          <span v-if="!batch_loading">
            <button
              v-if="prescriptions.length > 0"
              @click="issue_prescription()"
              class="btn btn-primary btn-sm"
            >
            <span v-if="restrict_unpaid">Issue only Ready prescription(s)</span>
            <span v-if="!restrict_unpaid">Issue prescription</span>
              
            </button>
          </span>

          <span
            style="
              border-bottom: 1em;
              color: black;
              font-weight: bold;
              margin-right: 1em;
            "
            v-if="batch_loading"
          >
            SKU Loading...
          </span>
        </span>
      </div>
      <!-- </div> -->
    </div>
    <!-- </div> -->
  </div>
  <!--  -->
  <message_dialogueModal
    @close-message-dialogue="closeMessageDialogue"
    :title="dialogue_title"
    :message="dialogue_message"
    :pres_detail_id="focused_detail_id"
    v-if="showMessageDialogue"
  />
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
// import PatientInput from "../../Patients/components/patient_input.vue";
import ItemFormat from "../../Inventory/components/ItemName.vue";
import dob_to_age from "../../../timezone/dob_to_age.js";
import iteminput from "../../Inventory/components/iteminput.vue";
import { JsItemName } from "../../Inventory/components/jscomponents.js";
import message_dialogueModal from "./message_dialogueModal.vue";
// import { color } from "chart.js/helpers";

export default {
  name: "IssuePrescriptionModal",
  data() {
    return {
      patient_name: "",
      patient_id: "",
      age: "",
      dob: "",
      gender: "",
      opd: "",
      ipd: "",
      phone: "",
      passport: "",
      residence: "",
      email: "",
      loading: true,
      prescriptions: [],
      batches: [],
      rowsOnEditMode: [],
      editValues: {},
      showMessageDialogue: false,
      focused_detail_id: "",
      dialogue_message: "",
      dialogue_title: "",
      batch_loading: false,
      restrict_unpaid: false,
    };
  },
  props: {
    pres_id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ItemFormat,
    iteminput,
    message_dialogueModal,
  },

  methods: {
    async issue_prescription() {
      this.loading = true;
      const url = "issue_prescription";
      const body = {
        pres_id: this.pres_id,
      };
      const res = await generalApiRequest(url, "POST", body, 1);
      console.log(res);
      this.loading = false;
      this.closepModal();
    },
    async changeSku(prescription_detail_id, e) {
      this.batch_loading = true;
      const url = "choose_prescription_batch";
      const body = {
        sku: e.target.value,
        pres_detail_id: prescription_detail_id,
      };
      const res = await generalApiRequest(url, "POST", body, 1);
      if (res) {
        this.batch_loading = false;
      }
      this.batch_loading = false;
    },
    displayConfirmDeleteMessageDialogue(detailed_id) {
      this.focused_detail_id = detailed_id;
      this.dialogue_message =
        "Do you SURE want to delete this prescription #SID: " + detailed_id;
      this.dialogue_title = "Confirmation";
      this.showMessageDialogue = true;
    },
    closeMessageDialogue() {
      this.showMessageDialogue = false;
      this.callApi();
    },
    handleEditChange(detail_id, e) {
      if (!this.editValues[detail_id]) {
        this.editValues[detail_id] = {};
      }
      this.editValues[detail_id][e.target.name] = e.target.value;
    },
    async saveEdits() {
      this.loading = true;
      const url = "save_prescription_edits";
      const body = {
        edits: this.editValues,
      };
      const res = await generalApiRequest(url, "POST", body, 1);
      // console.log(res);

      if (res.data) {
        this.callApi();
      }
    },
    takeItem(detail_id, payload) {
      if (!this.editValues[detail_id]) {
        this.editValues[detail_id] = {};
      }
      this.editValues[detail_id]["new_drug"] = payload.id;
    },
    async callApi() {
      // console.log("api is being called");
      this.loading = true;
      const url = "view_user_prescriptions";
      const body = {
        pres_id: this.pres_id,
      };
      const res = await generalApiRequest(url, "POST", body, 1);

      console.log("this is the user_prescription==========");

      console.log(res);

      this.patient_name = res.patient.name;
      // this.age = res.patient.
      this.dob = res.patient.dob;
      this.gender = res.patient.gender;
      this.opd = res.patient.opd;
      this.ipd = res.patient.ipd;
      this.phone = res.patient.phone;
      this.passport = res.patient.id_number;
      // this.residence = res.patient.
      this.email = res.patient.email;

      this.prescriptions = res.data;
      this.restrict_unpaid = res.restrict_unpaid;
      // get batches
      var detail_ids = [];
      res.data.forEach((element) => {
        detail_ids.push(element.id);
      });

      const sku_url = "view_prescription_skus";
      const sku_body = {
        pres_details_ids: detail_ids,
      };

      const sku_res = await generalApiRequest(sku_url, "POST", sku_body, 1);
      // console.log(sku_res);
      this.batches = sku_res.data;
      this.editValues = {};
      this.rowsOnEditMode = [];
      console.log(this.editValues);

      this.loading = false;
    },

    getPreSelectedItem(brand_name, item_strength, item_name) {
      return JsItemName(brand_name, item_strength, item_name);
    },

    switchEditMode(row) {
      this.rowsOnEditMode = [...this.rowsOnEditMode, row];
      // var prev = this.rowsOnEditMode;
      // prev.push(row);
      // // console.log(cur);
      // this.rowsOnEditMode = prev;
    },

    getAge(dob) {
      return dob_to_age(dob);
    },

    closepModal() {
      this.$emit("close-add-pres-modal");
    },

    change_input(e) {
      this[e.target.name] = e.target.value;
      if (e.target.name == "age") {
        // console.log( this.calculateDateOfBirth(e.target.value) );
        this.dob = this.calculateDateOfBirth(e.target.value);
      }

      const body = {
        patient_name: this.patient_name,
        patient_id: this.patient_id,
        age: this.age,
        dob: this.dob,
        dob_age: this.dob_age,
        gender: this.gender,
        opd: this.opd,
        phone: this.phone,
        passport: this.passport,
        residence: this.residence,
        email: this.email,
        clinic: this.clinic,
        appointment_data: this.appointment_data,
      };

      console.log(body);
    },
  },

  mounted() {
    this.callApi();
  },
};
</script>

<style scoped>
.dot_line {
  border-style: dotted;
  border-width: 1px;
}

.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
}
.modal-body {
  padding: 1em;
}

/* ghjkl */
input[type="number"],
input[type="text"] {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease;
}

input[type="number"]:focus,
input[type="text"]:focus {
  border-color: #4a90e2;
  outline: none;
  box-shadow: 0 0 5px rgba(74, 144, 226, 0.5);
}

/* Remove spinner arrows only on number inputs */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
